import * as React from 'react';
import Icon from './icon';
import * as ReactDOM from 'react-dom';

export interface ModalProps {
    visible?: boolean;
    onCancel?: () => void;
    closeOnDimmer?: boolean;
    className?: string;
    size?: 'small' | 'medium' | 'large' | 'complete';
    closable?: boolean;
    type?: 'light' | 'dark' | 'grey';
    style?: React.CSSProperties;
}

export interface ModalState {
    visible: boolean;
    cssState: string;
}

export default class Modal extends React.Component<ModalProps, ModalState> {
  constructor(props: ModalProps) {
    super(props);

    this.state = {
        visible: this.props.visible || false,
        cssState: this.props.visible? 'modal-show': 'modal-hide'
    }
  }

  public componentDidMount(){
      this.setState({visible: this.props.visible || false}, this.updateGlobalStatus);

  }

  updateGlobalStatus = () => {

    (window as any).store.dispatch({type: this.state.visible? "MODAL_UP": "MODAL_DOWN"});
  }

  public componentWillReceiveProps(nextProps: ModalProps)
  {
      if(nextProps.visible !== this.props.visible){
            
            this.setState({cssState: nextProps.visible? 'modal-show': 'modal-hide'});
            
            this.delayModalState(() => {
                this.setState({visible: nextProps.visible || false}, this.updateGlobalStatus);
            }, 0)

      }
  }

  delayModalState = (func: any, delay: number) => {

        var interval: any = null;
        const wrapper = () => {
            func();
            clearInterval(interval);
        }

        interval = setInterval(wrapper, delay);
  }

  handleDimmer = () => {

    if(this.props.closable){
      this.setState({cssState: 'modal-hide'})

      this.delayModalState(() => {
          if(this.props.closeOnDimmer)
          this.setState({visible: false}, this.updateGlobalStatus);
      
          if(this.props.onCancel)
              this.props.onCancel();
      }, 200);
    }
  }

  public render() {

    const { visible } = this.state;

    if(!visible)
      return null;


    const inner = (
        <div>
            <div className={`dimmer ${this.state.cssState}`} onClick={this.handleDimmer}></div>
            <div className={`modal-container ${this.state.cssState}`}  >
                
                {visible && <React.Fragment>
                    <div className={`modal ${this.props.size || 'large'} ${this.props.type || 'light'}  ${this.props.className || ''}`}>
                        {this.props.closable && <div className="modal-close" onClick={this.handleDimmer}><Icon type='close'/></div>}
                        <div className="modal-content">
                        {this.props.children}
                        </div>
                    </div>
                </React.Fragment>}
        </div>
      </div>
    );

    return ReactDOM.createPortal(
      inner,
      document.getElementById('modal-root') as any
    )
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/modal.tsx